global.AppConfig={
    server_host : 'http://127.0.0.1:8080'
}

export const FwTypeOptions = {
    "1": "wifi.cfg",
    "2": "FW package file"
  };